import React, { FC } from 'react';
import Image from 'components/image/Image';
import { Children } from 'core/interface/popup';

import './Index.scss';
import useLocales from 'hooks/useLocales';

export const Popup: FC<
  Children & {
    showCloseButton?: boolean;
    closeOnOverlayClick?: boolean;
    titleAction?: React.ReactNode;
  }
> = ({
  title,
  description,
  children,
  onClose,
  className,
  showCloseButton = true,
  closeOnOverlayClick = true,
  titleAction
}): JSX.Element => {
  const { t } = useLocales();
  const onModalClose = (): void => {
    onClose();
  };

  return (
    <div className="popup">
      <div
        onClick={closeOnOverlayClick ? onModalClose : undefined}
        className="popup__content"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={`popup__content__main ${className ?? ''} scrollable`}
        >
          <div
            className={`popup__header ${
              showCloseButton ? 'popup__header--with-close' : ''
            }`}
            style={{ paddingBottom: description ? 0 : '20px' }}
          >
            <span className="popup__header-side" aria-hidden />
            <div className="popup__title-wrap">
              <h2 className="popup__title">{t(title) || title}</h2>
              {titleAction}
            </div>
            {showCloseButton ? (
              <button
                type="button"
                className="popup__content__main-close"
                onClick={onModalClose}
                aria-label={t('Close')}
              >
                <Image name="close.svg" width={22} height={22} />
              </button>
            ) : (
              <span className="popup__header-side" aria-hidden />
            )}
          </div>
          {description && (
            <p className="popup__desc">{t(description) || description}</p>
          )}
          <div className="popup__body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
